import React from 'react';

const SvgErrorStateIcon = props => (
  <svg
    width={props.width || 288}
    height={props.height || 191.106}
    viewBox="0 0 288 191.106"
    {...props}
  >
    <g id="img-empty-state" transform="translate(-450.658 -230.454)">
      <path
        id="Trazado_188"
        data-name="Trazado 188"
        d="M300.074,92.423H271.44A83.732,83.732,0,0,0,136.043,40.8h-28.9A12.745,12.745,0,0,0,94.421,53.524h0a12.8,12.8,0,0,0,10.6,12.556h20.6A13.922,13.922,0,0,1,139.5,79.966v1.561a13.922,13.922,0,0,1-13.885,13.885H84.423A12.745,12.745,0,0,0,71.7,108.135h0a12.745,12.745,0,0,0,12.723,12.722H106.38a83.725,83.725,0,0,0,134.068,50.824,12.4,12.4,0,0,0,3.355.465h32.421a12.745,12.745,0,0,0,12.723-12.722h0A12.745,12.745,0,0,0,276.224,146.7H257.09A13.624,13.624,0,0,1,243.5,133.115v-1.794a13.624,13.624,0,0,1,13.586-13.586h30.727a11.7,11.7,0,0,1,2.192.2h10a12.745,12.745,0,0,0,12.723-12.722h0A12.682,12.682,0,0,0,300.074,92.423Z"
        transform="translate(402.597 232.008)"
        fill="#fff3f2"
      />
      <path
        id="Trazado_186"
        data-name="Trazado 186"
        d="M25.113,103.778H11.527A11.583,11.583,0,0,1,0,92.218V89.827A11.576,11.576,0,0,1,11.527,78.3H25.08A11.554,11.554,0,0,1,36.606,89.827v2.392A11.533,11.533,0,0,1,25.113,103.778Z"
        transform="translate(450.658 194.477)"
        fill="#fff3f2"
      />
      <path
        id="Trazado_187"
        data-name="Trazado 187"
        d="M781.88,422.645H768.327A11.554,11.554,0,0,1,756.8,411.118v-2.392A11.554,11.554,0,0,1,768.327,397.2H781.88a11.554,11.554,0,0,1,11.527,11.527v2.392A11.576,11.576,0,0,1,781.88,422.645Z"
        transform="translate(-54.748 -18.491)"
        fill="#fff3f2"
      />
      <ellipse
        id="Elipse_149"
        data-name="Elipse 149"
        cx={5.126}
        cy={5.126}
        rx={5.126}
        ry={5.126}
        transform="translate(518.191 232.454)"
        fill="none"
        stroke="#fd9791"
        strokeMiterlimit={10}
        strokeWidth={4}
      />
      <ellipse
        id="Elipse_151"
        data-name="Elipse 151"
        cx={5.126}
        cy={5.126}
        rx={5.126}
        ry={5.126}
        transform="translate(676.058 307.212)"
        fill="none"
        stroke="#fd9791"
        strokeMiterlimit={10}
        strokeWidth={4}
      />
      <path
        id="Trazado_190"
        data-name="Trazado 190"
        d="M225.61,205.431h-7.922v-7.922a1.709,1.709,0,1,0-3.418,0v7.922h-7.961a1.709,1.709,0,1,0,0,3.418h7.922v7.922a1.709,1.709,0,1,0,3.418,0v-7.922h7.922a1.724,1.724,0,0,0,1.709-1.709A1.666,1.666,0,0,0,225.61,205.431Z"
        transform="translate(301.164 111.607)"
        fill="#fd9791"
      />
      <path
        id="Trazado_191"
        data-name="Trazado 191"
        d="M729.331,257.567l-4.35-4.35,4.35-4.35A1.318,1.318,0,0,0,727.467,247l-4.349,4.35-4.35-4.35a1.318,1.318,0,0,0-1.864,1.864l4.35,4.35-4.35,4.35a1.318,1.318,0,0,0,1.864,1.864l4.35-4.35,4.349,4.35a1.337,1.337,0,0,0,1.864,0A1.269,1.269,0,0,0,729.331,257.567Z"
        transform="translate(-11.952 80.52)"
        fill="#fd9791"
      />
      <g
        id="Grupo_230"
        data-name="Grupo 230"
        transform="translate(540.004 376.972)"
      >
        <g id="Grupo_229" data-name="Grupo 229">
          <path
            id="Trazado_195"
            data-name="Trazado 195"
            d="M305.516,379.262h99.631a1.932,1.932,0,0,0,0-3.862H305.516a1.932,1.932,0,0,0,0,3.862Z"
            transform="translate(-303.65 -375.4)"
            fill="#fd635b"
          />
        </g>
      </g>
      <g
        id="Grupo_232"
        data-name="Grupo 232"
        transform="translate(652.507 376.972)"
      >
        <g id="Grupo_231" data-name="Grupo 231">
          <path
            id="Trazado_196"
            data-name="Trazado 196"
            d="M567.716,379.262h7.08a1.932,1.932,0,0,0,0-3.862h-7.08a1.932,1.932,0,0,0,0,3.862Z"
            transform="translate(-565.85 -375.4)"
            fill="#fd635b"
          />
        </g>
      </g>
      <g
        id="Grupo_234"
        data-name="Grupo 234"
        transform="translate(505.764 376.972)"
      >
        <g id="Grupo_233" data-name="Grupo 233">
          <path
            id="Trazado_197"
            data-name="Trazado 197"
            d="M225.716,379.262h22.226a1.932,1.932,0,0,0,0-3.862H225.716a1.932,1.932,0,0,0,0,3.862Z"
            transform="translate(-223.85 -375.4)"
            fill="#fd635b"
          />
        </g>
      </g>
      <g id="alert-circle-outline" transform="translate(561.285 292.968)">
        <path
          id="Trazado_584"
          data-name="Trazado 584"
          d="M132.078,98.039a34.039,34.039,0,1,0-34.039,34.039A34.048,34.048,0,0,0,132.078,98.039Z"
          transform="translate(-64 -64)"
          fill="none"
          stroke="#fd635b"
          strokeMiterlimit={10}
          strokeWidth={4}
        />
        <path
          id="Trazado_585"
          data-name="Trazado 585"
          d="M250.255,161.113l1.018,21.62,1.016-21.62a1.018,1.018,0,0,0-1.026-1.064h0a1.018,1.018,0,0,0-1.007,1.064Z"
          transform="translate(-217.234 -143.021)"
          fill="none"
          stroke="#fd635b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={4}
        />
        <path
          id="Trazado_586"
          data-name="Trazado 586"
          d="M239.546,335a3.546,3.546,0,1,1,3.546-3.546A3.546,3.546,0,0,1,239.546,335Z"
          transform="translate(-205.507 -281.122)"
          fill="#fd635b"
        />
      </g>
    </g>
  </svg>
);

export default SvgErrorStateIcon;
